// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2-k4r","unreadBadge":"styles_unreadBadge__35wgn","modalContent":"styles_modalContent__2QjZe","modal":"styles_modal__2eS3p"};